import { render, staticRenderFns } from "./bulma_table_IS.vue?vue&type=template&id=48c5ad87&scoped=true&lang=html"
import script from "./bulma_table_IS.vue?vue&type=script&lang=js"
export * from "./bulma_table_IS.vue?vue&type=script&lang=js"
import style0 from "./bulma_table_IS.vue?vue&type=style&index=0&id=48c5ad87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c5ad87",
  null
  
)

export default component.exports